import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetRewardProgramActivityLogByRewardProgramId = (
  rewardProgramId: number
) => {
  const get = useTypedApiClient({
    path: '/admin/rewards-programs-activity-log/rewardsProgram/{rewardProgramId}',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/admin/rewards-programs-activity-log', rewardProgramId],
    queryFn: async () => {
      const { data } = await get({ rewardProgramId })
      return data
    },
  })
}
